import React, { FC } from 'react';
import { useQuery } from 'react-query';
import RequirableSelect from '../RequireableSelect';

interface SubsouceSelectFormGroupProps {
  supersourceId: number | undefined;
  selectedSubsourceId: number | undefined;
  formIndex: string;
  onChange: (subsourceId: number) => void;
  overrideFormName: string;
}

const SubsourceSelectFormGroup: FC<SubsouceSelectFormGroupProps> = ({
  formIndex,
  supersourceId,
  selectedSubsourceId,
  onChange,
    overrideFormName,
}) => {
  const { isLoading, data, error } = useQuery<any, Error, {id: number, name: string}[]>(
    `supersource-${supersourceId}-subsources`,
    async () => $.get(`/admin/api/supersource/${supersourceId}/subsources`),
    {
      enabled: !!supersourceId,
    },
  );
  let formName = 'module_instances';
  if (overrideFormName !== undefined) {
    formName = overrideFormName;
  }

  const subsourceOpts = (data || []).map(subsource => ({ value: subsource.id, label: subsource.name }));

  return (
    <div className="form-group">
      <label htmlFor={`${formName}-${formIndex}-subsource`}>
        SUBSOURCE
      </label>
      <RequirableSelect
        options={subsourceOpts}
        onChange={evt => onChange(evt.value)}
        isSearchable
        required
        inputId={`${formName}-${formIndex}-subsource`}
        name={`${formName}-${formIndex}-subsource`}
        value={subsourceOpts.find(opt => opt.value === selectedSubsourceId) ?? null}
        isLoading={isLoading}
      />
      {error && <span>Error: {error.message}</span>}
    </div>
  );
};

export default SubsourceSelectFormGroup;
